import { createContext } from 'react';

import ISupportCaseContext from './interface/support-case-context';

const SupportCaseContext = createContext<ISupportCaseContext>({
  isLoading: false,
  fetchCompleted: false,
  hasCompleted: false,
  supportCases: [],
  hasSupportCases: false,
  findSupportCase: async () => Promise.resolve({} as never),
  addSupportCaseComment: async () => Promise.resolve({} as never),
  closeSupportCase: async () => Promise.resolve({} as never),
  downloadAttachment: async () => Promise.resolve({} as never),
});

export default SupportCaseContext;
